module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./OrderEvaluateView.js"));
	}, "OrderEvaluateView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderEvaluateView!./src/pages/Shop/Member/TradeManage/OrderEvaluate/OrderEvaluateView.js
// module id = 1522
// module chunks = 418